import React, { useEffect } from 'react'

const GSSC = () => {
  useEffect(() => {
    window.location.replace('https://globalstudentstartup.org/');
}, []);
  return (
    <div>GSSC</div>
  )
}

export default GSSC
